<template>
  <picture>
    <source type="image/webp" :srcset="source + '.webp'" />
    <source :type="formatSource.type" :srcset="source + formatSource.ext" />
    <img
      :src="src"
      alt="blog post thumbnail"
      class="thumbnail img-responsive"
    />
  </picture>
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    host: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  computed: {
    source() {
      return this.src.replace(/.jpg|.png|.webp|.jpeg/g, "");
    },
    format() {
      const arr = this.src.split(".");
      return arr[arr.length - 1];
    },
    formatSource() {
      const format = this.format;
      let output = ".jpg";
      let type = "image/jpeg";
      if (format === "jpeg") {
        output = ".jpeg";
      } else if (format === "png") {
        output = ".png";
        type = "image/png";
      }
      return { ext: output, type: type };
    }
  },
  methods: {}
};
</script>
